export { default } from './Tooltip';


// WEBPACK FOOTER //
// ./src/components/shared/Tooltip/index.ts